<template lang="pug">
v-card(class='auth-form')
  v-toolbar(dark flat color='primary')
    v-toolbar-title Сброс пароля
  v-card-text(class='pt-5')
    v-alert(
      :value='errors.has("common")'
      :dismissible='true'
      type='error'
      outline
      class='mb-5'
    )
      | {{ errors.first('common') }}
    v-form(@keyup.native.enter='tryReset')
      v-text-field(
        :error='errors.has("phone")'
        :error-messages='errors.first("phone")'
        :prefix='focused || user.phone ? "+7" : ""'
        @focus="focused=true"
        @blur="focused=false"
        v-model='user.phone'
        prepend-icon='phone'
        name='phone'
        label='Телефон'
        type='text'
        mask=' (###) ###-##-##'
      )
      div(class='or') или
      v-text-field(
        :error='errors.has("email")'
        :error-messages='errors.first("email")'
        v-model='user.email'
        prepend-icon='email'
        name='email'
        label='Email'
        type='text'
      )
  v-card-actions(class='card-actions')
    v-layout(column align-content-center)
      v-flex
        v-btn(
          @click='tryReset'
          :loading='loading'
          color='primary'
          type='submit'
          block
          large
        ) Сбросить пароль
      v-flex(class='register')
        router-link(:to='{ name: "Auth.Login" }') Аторизация
</template>

<script>
import { isEmpty } from 'lodash'
import { mapActions, mapMutations } from 'vuex'

export default {
  data: () => ({
    user: {
      phone: ''
    },
    loading: false,
    focused: false
  }),

  methods: {
    tryReset() {
      this.loading = true

      this.logout()

      this.resetPassword(this.user)
        .then(() => {
          if (isEmpty(this.user.phone)) {
            this.$router.push({
              name: 'Auth.ResetNotify',
              query: {
                mail: this.user.email
              }
            })
          } else {
            this.$router.push({
              name: 'Auth.ResetConfirmPhone',
              params: {
                id: this.user.phone
              }
            })
          }
        })
        .catch(e => {
          this.$showServerErrors(e)
        })
        .finally(() => {
          this.loading = false
        })
    },

    ...mapActions('auth', ['resetPassword']),
    ...mapMutations('auth', ['logout'])
  }
}
</script>

<style scoped>
.register {
  padding: 16px;
  text-align: center;
}
</style>
